import React from 'react';
import ReactDOM from 'react-dom';
import './App.scss';
import App from './App';
import store from 'app/state/redux/configureStore';
import { Provider } from 'react-redux';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
